/**
 * @generated SignedSource<<a83d03bd1e678ad7a75ce65404b20605>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type jiraSingleWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraSingleWorkItemPreviewCard$data = {
  readonly jira_projectByIdOrKey: {
    readonly key: string;
    readonly " $fragmentSpreads": FragmentRefs<"previewContent_AtlassianConversationAssistantPreviewCard">;
  } | null;
  readonly " $fragmentType": "jiraSingleWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraSingleWorkItemPreviewCard";
};
export type jiraSingleWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraSingleWorkItemPreviewCard$key = {
  readonly " $data"?: jiraSingleWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraSingleWorkItemPreviewCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"jiraSingleWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraSingleWorkItemPreviewCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "projectIdOrKey"
    }
  ],
  "kind": "Fragment",
  "name": "jiraSingleWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraSingleWorkItemPreviewCard",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "idOrKey",
          "variableName": "projectIdOrKey"
        }
      ],
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "jira_projectByIdOrKey",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "FragmentSpread",
          "name": "previewContent_AtlassianConversationAssistantPreviewCard"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "285076a290432900dc371c79d19d4238";

export default node;
